import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 360px;
  column-gap: 10px;

  .otp-input {
    width: 100%;
    height: 45px;
    border: 1px solid #ccc;
    border-radius: 5px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    outline: none;
    outline-width: 0;
    -webkit-appearance: none;
  }

  input:focus-visible {
    box-shadow: 0 0 6px #94c840;
  }
`;

export default Wrapper;
